import dayjs from 'dayjs'
import utc from 'dayjs/plugin/utc'
import timezone from 'dayjs/plugin/timezone'

dayjs.extend(utc)
dayjs.extend(timezone)

const accionesMap = {
    cedida: 'Cedida',
    recuperada: 'Recuperada',
    acceso_original_invalidado: 'Acceso original invalidado',
    acceso_cedido_generado: 'Acceso cedido generado',
    acceso_original_restaurado: 'Acceso original restaurado',
    acceso_cedido_revocado: 'Acceso cedido revocado'
}

const badgeClassMap = {
    cedida: 'tw:bg-sky-100 tw:text-sky-700 tw:ring-sky-200',
    recuperada: 'tw:bg-emerald-100 tw:text-emerald-700 tw:ring-emerald-200',
    acceso_original_invalidado: 'tw:bg-amber-100 tw:text-amber-800 tw:ring-amber-200',
    acceso_cedido_generado: 'tw:bg-blue-100 tw:text-blue-700 tw:ring-blue-200',
    acceso_original_restaurado: 'tw:bg-green-100 tw:text-green-700 tw:ring-green-200',
    acceso_cedido_revocado: 'tw:bg-rose-100 tw:text-rose-700 tw:ring-rose-200'
}

const rowClassMap = {
    cedida: 'tw:bg-sky-50/70',
    recuperada: 'tw:bg-emerald-50/70',
    acceso_cedido_revocado: 'tw:bg-rose-50/70'
}

export function formatCesionAccion(accion) {
    return accionesMap[accion] || accion || '—'
}

export function getCesionActionBadgeClass(accion) {
    return [
        'tw:inline-flex tw:items-center tw:rounded-full tw:px-3 tw:py-1 tw:text-xs tw:font-semibold tw:ring-1 tw:ring-inset',
        badgeClassMap[accion] || 'tw:bg-slate-100 tw:text-slate-700 tw:ring-slate-200'
    ].join(' ')
}

export function getCesionRowClass(accion) {
    return rowClassMap[accion] || 'tw:bg-white'
}

export function formatCesionDate(dateString) {
    if (!dateString) {
        return '—'
    }

    try {
        return dayjs(dateString).format('DD/MM/YYYY HH:mm')
    } catch {
        return dateString
    }
}
